<template>
  <div class="activity-modal" v-exposure="{ eid: `119_0_0_0` }" :data-id="`119_0_0_0`">
    <img v-if="taken" class="activity-close" :src="closeBtn" alt="" @click="close" />
    <el-carousel
      class="activity-lunbo"
      ref="activityCarousel"
      :autoplay="list.length > 1"
      :loop="list.length > 1"
      indicator-position="none"
      arrow="never"
      trigger="click"
      :height="$px2rem(imgHeight + 50)"
    >
      <el-carousel-item v-for="item in list" :key="item.id">
        <div class="img_content">
          <img ref="imageRef" :src="getNotice(item.languages || {})" alt @load="imgLoad" @click="clickFun(item)" />
        </div>

        <div class="btns">
          <el-button
            v-if="item.jump?.type && item.languages?.buttonText"
            v-exposure="{ eid: `119_0_0_119002` }"
            :data-id="`119_0_0_119002`"
            class="btn btn1"
            size="medium"
            @click="clickFun(item)"
          >
            {{ item.languages?.buttonText }}
          </el-button>
          <!-- <el-button
            v-if="!taken"
            v-exposure="{ eid: `119_0_0_119001` }"
            :data-id="`119_0_0_119001`"
            class="btn btn2"
            size="medium"
            @click="onGoRegister"
          >
            <span>{{ $t("Datalang.HomePage_BTM_register") }}</span>
            <img class="icon" :src="require(`@/lobby_common/assets/activity/gif.png`)" alt="" srcset="" />
          </el-button> -->
        </div>
      </el-carousel-item>
    </el-carousel>
    <div v-if="list.length > 1">
      <div class="el-carousel__arrow arrow-left" @click="arrowClick('left')"><img :src="arrowImg" alt="" /></div>
      <div class="el-carousel__arrow arrow-right" @click="arrowClick('right')"><img :src="arrowImg" alt="" /></div>
    </div>
  </div>
</template>

<script>
import eventsModal from "@/lobby_common/mixins_components/homeActivityModal/index.js";
export default {
  components: {},
  props: [],
  mixins: [eventsModal],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.activity-modal {
  position: relative;
  box-sizing: border-box;
  padding: 0 50px;
  transform: translateY(-20px);
  .activity-close {
    position: absolute;
    top: 0px;
    right: 0;
    width: 32px;
    cursor: pointer;
    z-index: 2;
  }
  .el-carousel__arrow {
    width: 26px;
    height: 44px;
    border-radius: 0;
    background-color: transparent;
    z-index: 2;
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      display: none;
    }
    &.arrow-left {
      left: 0px;
    }
    &.arrow-right {
      right: 0px;
      img {
        transform: rotate(180deg);
      }
    }
    img {
      width: 100%;
    }
  }
}
.activity-lunbo {
  z-index: 1;
  .el-carousel__container {
    // min-height: 400px;
    height: auto;
    // padding-bottom: 50px;

    .el-carousel__item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // position: relative;
    }

    .title {
      font-size: 20px;
      color: #000;
      font-weight: 600;

      span {
        font-size: 12px;
        color: #666666;
      }
    }

    .img_content {
      width: 100%;
      // padding-bottom: 50px;
      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
        cursor: pointer;
      }
    }

    .btns {
      text-align: center;
      bottom: 0px;
      // margin-top: 20px;
      width: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      .btn {
        padding: 10px 20px;
        border: none;
        @include text-ellipsis;
        &:hover {
          opacity: 1 !important;
        }
        &.btn1 {
          background: var(--button-100);
          color: var(--font-color-1300);
        }
        &.btn2 {
          background: var(--button-200);
          color: var(--font-color-1400);
          min-width: 150px;
          height: 40px;
          position: relative;
          & > span {
            display: flex;
            align-items: center;
            justify-content: center;

            & > span {
              padding-right: 12px;
              // @include text-ellipsis;
              // overflow: hidden;
            }
          }
          .icon {
            position: absolute;
            right: -5px;
            top: 50%;
            height: 40px;
            transform: translateY(-50%);
          }
        }
      }
    }

    .system-time {
      padding: 10px 0;
      font-size: 12px;
      padding-left: 15px;
    }

    .swiper-content {
      font-size: 16px;
      white-space: pre-line;
    }
  }
}
@media (max-width: 768px) {
  .activity-modal {
    padding: 0 !important;
    .activity-close {
      width: 28px;
    }
    .el-carousel__arrow {
      width: 18px;
      height: 30px;
    }
    // .el-carousel__container {
    //   // min-height: 480px;
    // }
  }
  .img_content {
    // max-width: 300px;
    margin: 0 auto;
  }
}
// @media (max-width: 375px) {
//   .activity-modal {
//     .el-carousel__container {
//       // min-height: 444px;
//     }
//   }
// }
// @media (max-width: 350px) {
//   .activity-modal {
//     .el-carousel__container {
//       // min-height: 400px;
//     }
//   }
// }
</style>
